const DirectionLeftIcon = (props) => (
	<svg 
		xmlns="http://www.w3.org/2000/svg" 
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props} 
	>
		<path d="M11 7H5M5 7L9 3M5 7L9 11" strokeWidth="2"/>
	</svg>
)

export default DirectionLeftIcon